import { AxiosError } from 'axios';

import { selectOrganisationInfos } from '@/domain/organisation/organisation.selectors';
import { getProjectsFestival } from '@/domain/project-festival/actions/get-projects-festival.action';
import { ProjectFestival } from '@/domain/project-festival/entities/project-festival.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  project: ProjectFestival;
};

export const createProjectFestival = createAppAsyncThunk(
  'projectFestival/createProjectFestival',
  async (
    params: Params,
    { extra: { projectFestivalGateway, snackbarGateway }, dispatch, getState },
  ): Promise<void> => {
    const organisationInfos = selectOrganisationInfos(getState());
    try {
      params.project.organisationId = organisationInfos.id;
      await projectFestivalGateway.create(params.project);
      showSnackbarSuccess(snackbarGateway);
      dispatch(getProjectsFestival());
    } catch (error) {
      let errorMessageKey = translate('CreateProject.Message.error');
      if (error instanceof AxiosError && error.status === 402) {
        errorMessageKey = translate('CreateProject.Message.limited');
      }
      showSnackbarError(snackbarGateway, errorMessageKey);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('CreateProject.Message.success'));
}

function showSnackbarError(
  snackbarGateway: SnackbarGateway,
  errorMessageKey: string,
) {
  snackbarGateway.error(errorMessageKey);
}
